/* eslint import/no-named-as-default: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import AppContainer from 'common/containers/app-container';

export default class AppRouter extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    view: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Provider store={this.props.store}>
        <BrowserRouter>
          <div>
            <Route
              {...this.props}
              component={AppContainer}
              path={window.location.pathname}>
              <Route path={'/:query'} />
            </Route>
          </div>
        </BrowserRouter>
      </Provider>
    );
  }
}
